import { render, staticRenderFns } from "./HeaderNavigationItem.vue?vue&type=template&id=e1a153d8&"
import script from "./HeaderNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavigationItem.vue?vue&type=style&index=0&id=e1a153d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports